export const blockIconsNotificationConfirmationNumber = (
	<span className='material-symbols-outlined'>confirmation_number</span>
);
